var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserEmailSentOld = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C5.89543 6 5 6.89543 5 8V12C5 13.1046 5.89543 14 7 14H13C14.1046 14 15 13.1046 15 12V8C15 6.89543 14.1046 6 13 6H7ZM13.978 7.31965C13.8689 7.09521 13.6162 7.01124 13.4136 7.13209L10 9.16811L6.58643 7.13209C6.38381 7.01124 6.13112 7.09521 6.02202 7.31965C5.91292 7.54408 5.98873 7.82399 6.19134 7.94483L9.80245 10.0987C9.92578 10.1722 10.0742 10.1722 10.1975 10.0987L13.8086 7.94483C14.0113 7.82399 14.0871 7.54408 13.978 7.31965Z",
    fill: "#F8F9FB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserEmailSentOld);
export default ForwardRef;